import * as FormulaFunctions from './FormulaFunctions';
import * as CoreFns from './CoreFns';
import * as HelperFunctions from './HelperFunctions';
import * as SharedAcross from './SharedAcross';
import * as ResponsiveFns from './ResponsiveFns';
import * as EditorHelpers from './EditorHelpers';

/* global BigInt */

export function doStartSim(currentList, setAppInfo, setOwnVariables, setMusicStatus, width, height, urlParamsForExecution, urlHeader, chains){

    var internalVariables = getVariablesThatChange();
    var ownVariablesOut = getOwnVariableDefaultValues(currentList, internalVariables, width, height, urlParamsForExecution, urlHeader, chains);
    setOwnVariables(ownVariablesOut);

    var musicPieces = currentList.mu;
    if (musicPieces){
      var musicPiecesKeys = Object.keys(musicPieces);
      var muOut = {}
      musicPiecesKeys.forEach((aMusicPieceKey, index)=>{
        muOut[aMusicPieceKey] = false;
      })
      setMusicStatus(muOut)
    }

    var inputValues = {};
    var appInfo = {inputValues, alertVisibility:{}, account:'', network:0, internalVariables, urlParamsForExecution, urlHeader};
    setAppInfo(appInfo);    
}

export function dappBaselineStyle(currentList, internalVariables, insetWidth, insetHeight, inputValues, ownVariables, urlParamsForExecution, urlHeader, chains){
  var overallS = {};
  if (currentList.s){
    var upwardInfo = [];
    overallS = evaluateStyleR('DAPP', currentList.s, ['s'], currentList, internalVariables, insetWidth, insetHeight, upwardInfo, inputValues, ownVariables, urlParamsForExecution, urlHeader, chains);
  }
  if (!overallS.color){
    overallS.color = 'black';
  }
  return overallS;  
}
export function screenWidthsAndHeights(screenSize){
  var insetWidth = 414; var insetHeight = 736;
  if (screenSize === 1){
    insetWidth = 736; insetHeight = 414;
  }else if (screenSize === 2){
    insetWidth = 768; insetHeight = 1024
  }else if (screenSize === 3){
    insetWidth = 1024; insetHeight = 600;
  }else if (screenSize === 4){
    insetWidth = 1280; insetHeight = 664;
  }
  return {insetWidth, insetHeight};  
}
export function imgInfoBaseline(w, h){
  return {oW:w, oH:h, rot:{t:'dc',v:0}, sca:{t:'dc',v:1}, cL:{t:'dc', v:0}, cR:{t:'dc', v:0}, cT:{t:'dc', v:0}, cB:{t:'dc', v:0}}
}

export function isFirstLevel(pathDown){
  if (pathDown[0] === 'fo'){
    return pathDown.length === 3;
  }else if (pathDown[0] === 'fe' || pathDown[0] === 'pu'){
    if (pathDown[4] === 'al'){
      return pathDown.length === 8;
    }
    return pathDown.length === 6;
  }
}

export function isFirstLevelAbsolute(objPath){
  return isFirstLevel(objPath) && objPath[4] === 'i';
}

export function addPointerIfGotClick(thisItem, s){
  if (thisItem.oc){
    if (thisItem.oc.click){
      if (thisItem.oc.click.t){
        s.cursor = 'pointer';
      }
    }
  }
}
export function sizePointer(screenSize) {
  if (screenSize === 1){
    return 'sm';
  }else if (screenSize === 2){
    return 'md';
  }else if (screenSize === 3){
    return 'lg'
  }else if (screenSize === 4){
    return 'xl';
  }else{
    return 'v';
  }

}
export function expandBIU(style){
  if (style.B){
    style.fontWeight = 600;
  }
  if (style.I){
    style.fontStyle = 'italic';
  }
  if (style.U){
    style.textDecoration = 'underline';
  }
}
export function extendWithGI(upwardInfo){
  return upwardInfo.filter((aU, index)=>{return aU.t.indexOf('gI_') === 0}).map((aU, index)=>{
          return '_' + aU.v;
        }).join(' ');
}

export function iterateClassNames(start, list, allStyles){
  var classNames = [start];
  list.forEach((anItem, index)=>{
    if (allStyles[anItem]){
      var value = allStyles[anItem];
      if (anItem === 'justifyContent'){
        value = 'justify-content-' + value;
      }
      classNames.push(value);
    }
  })      
  return classNames.join(' ');
}

function positiveTimeSplit(diff){
    // var diff = Math.floor(timeDiff / 1000);
    var nosSeconds = diff - 60 * Math.floor(diff/60);
    var min = (diff - nosSeconds)/60;
    var nosMinutes = min - 60 * Math.floor(min/60);
    var hours = (min - nosMinutes)/60;
    var nosHours = hours - 24 * Math.floor(hours/24);
    var days = (hours - nosHours)/24;
    return {days, hours:nosHours, minutes:nosMinutes, seconds:nosSeconds};  
}

export function calcTimeSplit(timeDiff){
  if (timeDiff >= 0){
    return positiveTimeSplit(timeDiff);
  }else{
    var k = positiveTimeSplit(-timeDiff);
    if (k.days){
      k.days = -k.days;
    }else if (k.hours){
      k.hours = -k.hours;
    }else if (k.minutes){
      k.minutes = -k.minutes;
    }else if (k.seconds){
      k.seconds = -k.seconds;
    }
    return k;
  }
}

export function getTimeDelay(timeDiff){
  var {days, hours, minutes, seconds} = calcTimeSplit(timeDiff);

  function addPart(txt, measure, amt){
    if (txt || amt > 0){
      if (txt){
        txt += ', ';
      }
      txt += amt + ' ' + measure;
    }
    if (amt > 1){
      txt += 's';
    }
    return txt;
  }

  var txt = '';          
  txt = addPart(txt, 'day', days);
  txt = addPart(txt, 'hour', hours);
  txt = addPart(txt, 'minute', minutes);
  txt = addPart(txt, 'second', seconds);
  if (!txt){
    txt = '0 seconds';
  }
  return txt;
}

export function onClickItemChangeSelectionFn(setItemEdited, setIsShowingSomeDropDown){
  return function (item, screenPath){
    if (item.id){
      function toClick(e){    
        setIsShowingSomeDropDown(false);
        setItemEdited({t:'asset', v:item.id, path:['as', item.id], screenPath});
        var sel = document.getSelection();
        sel.removeAllRanges()
        if (e){
          e.stopPropagation();
        }
      }
      item.onclick= toClick;
    }
  }  
}

export function goToAnywhereFn(itemPath){
  return function(){
      var lastChild1 = document.getElementById('editor' + itemPath.join('_'));
      var children = lastChild1.childNodes;
      var lastChild;
      if (children.length > 0){
        var lastChildA = children[children.length - 1];
        if (lastChildA.tagName === 'TABLE' || lastChildA.tagName === 'DIV' ){
          lastChild = document.createTextNode('');
          lastChild1.appendChild(lastChild);
        }else{
          lastChild = lastChildA;
        }

      }else{
        lastChild = document.createTextNode('');
        lastChild1.appendChild(lastChild);
      }
      var sel = document.getSelection();
      var range = document.createRange();
      sel.removeAllRanges()
      range.setStart(lastChild,lastChild.length);
      range.setEnd(lastChild,lastChild.length);
      sel.addRange(range)
  }  
}


export function shortenName(name){
  if (name.length < 9){
    return name;
  }else{
    return name.substr(0,2) + '...' + name.substr(name.length - 4);
  }
}

export function numberWithCommas(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}

/**
 * Checks if the given string is an address
 *
 * @method isAddress
 * @param {String} address the given HEX adress
 * @return {Boolean}
*/


// function isChecksumAddress(address) {
//     // Check each case
//   address = address.replace('0x','');
//   console.log(address);
//   var addressHash = SHA3(address.toLowerCase());
//   console.log(addressHash);
//   for (var i = 0; i < 40; i++ ) {
//       // the nth letter should be uppercase if the nth digit of casemap is 1
//       if ((parseInt(addressHash[i], 16) > 7 && address[i].toUpperCase() !== address[i]) || (parseInt(addressHash[i], 16) <= 7 && address[i].toLowerCase() !== address[i])) {
//           return false;
//       }
//   }
//   return true;
// }



export function makeDigits(digits){
  var x = '';
  for (var i = 0; i < digits; i++){
    x += '0';
  }
  return x;
}

export function makeADecimalTextIntoLongText(decimalText, digits){
  var isDec = SharedAcross.isDecimalText(decimalText);
  if (isDec){
    var locOfDot = decimalText.indexOf('.');
    if (locOfDot === -1){
      return decimalText + makeDigits(digits);
    }else{
      var before = decimalText.substr(0, locOfDot);
      var after = decimalText.substr(locOfDot + 1);
      if (after.length > digits){
        return before + after.substr(0, digits);      
      }else{
        return before + after + makeDigits(digits - after.length);
      }
    }
  }
  return '0';
}

export function makeADecimalTextIntoBigNum(decimalText, digits){
  return BigInt(makeADecimalTextIntoLongText(decimalText, digits));
}

export function getOwnVariableDefaultValues(currentList, internalVariables, width, height, urlParamsForExecution, urlHeader, chains){
  var ownVariablesOut = {}
  var inputValues = {}
  var ov = currentList.ov;
  if (ov){
      var ovKeys = CoreFns.sortedKeyList(ov);
      ovKeys.forEach((aKey, index)=>{
        var thisOV = ov[aKey];
        var type = CoreFns.convertSelectionToType(thisOV.t, currentList);
        var entityPath = ['ov', aKey];
        var upwardInfo = [];
        var val = FormulaFunctions.evaluateCondition(thisOV.d, type, entityPath, currentList, internalVariables, width, height, upwardInfo, inputValues, ownVariablesOut, urlParamsForExecution, urlHeader, chains);
        ownVariablesOut[aKey] = val;
      })           
  }
  return ownVariablesOut;
}
export function getInternalVariables(otherInfo, setOtherInfo, whichFEOrPU){
  var i = getVariablesThatChange();
  i.activeUser = '';
  i.chainInfo = {};
  i.chainId = 0;
  i.setChainInfo = function(e){};
  i.otherInfo = otherInfo;
  i.setOtherInfo = setOtherInfo;
  i.currentScreen = whichFEOrPU;

  return i;
}


export function numberOfDecimalsFromCurrentList(currentList, chains){
  var curr = CoreFns.goDownPath(currentList, ['_g', 'curr', 'o'], 0);
  return CoreFns.getRelevantChain(curr, chains).d;
}

export function correctChainName(currentList, chains){
  var curr = CoreFns.goDownPath(currentList, ['_g', 'curr', 'o'], 0);
  return CoreFns.chainNameFromId(curr, chains);
}

export function isCorrectChain(currentList, internalVariables){
  return HelperFunctions.pickUpInternalVariable(internalVariables, 'chainId')  === CoreFns.relevantChainId(currentList)
}


export function getVariablesThatChange(){
  return {dateTime:new Date(), date:(function(){var d = new Date(); d.setHours(0,0,0,0); return d})()};
}

export function marchDownToCleanUpH(path){
  var overall = [];
  var gotContainerBefore = false;
  for (var i = 0; i < path.length; i++){
    var aR = path[i];
    if (aR.t === 'h'){
      overall.push({t:'h',n:aR.n,v:[]});
      gotContainerBefore = true;
    }else{
      if (gotContainerBefore){
        var lastContainer = overall[overall.length - 1];
        lastContainer.v.push(aR);
      }else{
        overall.push(aR);
      }
    }
  }
  // if (overall.length > 1){
  //   var last = overall[overall.length - 1];
  //   var last2 = overall[overall.length - 2];
  //   if (last.t === 'br' && last2.t === 'a'){
  //     overall.push({t:'br'});      
  //   }    
  // }
  // if (overall[overall.l])
  // console.log(overall);
  // if (overall.length === 0){
  //   overall.push({t:'t',v:'1',s:{opacity:0}});
  // }
  return overall;
}


//


export function shouldShowInstructions(screen){
  var r = screen.x;
  if (r.length === 0){
    return true;
  }else if (r.length === 1){
    if (r[0].t === 'br'){
      return true;
    }
  }
  return false;
}

export function decimalWidthPieces(){
  return [{t:'vw', n:'Vertical Width'}, {t:'vh', n:'Vertical Height'}, {t:'perc', n:'Percentage'},  {t:'px', n:'Pixels'}, {t:'em', n:'Ems'}];
}

export function fontWidthPieces(limits){
  var opts = [{t:'em', n:'Ems'}, {t:'px', n:'Pixels'}, {t:'vw', n:'Vertical Width'}, {t:'vh', n:'Vertical Height'}]
  if (!limits){
    return opts;
  }else{
    return opts.filter((aP, index)=>{
      return limits.includes(aP.t);
    });
  }
}


export function getRelevantValueTgt(currentInputType, allowMultiple){
  if (currentInputType === 'Text String' || currentInputType === 'Single Select' || currentInputType === 'Long Text'){
    return 'valueString';
  }else if (currentInputType === 'Radio'){
    if (allowMultiple){
      return 'valueListString';
    }else{
      return 'valueString';
    }
  }else if (currentInputType === 'Integer'){return 'valueInteger';
  }else if (currentInputType === 'UInteger'){return 'valueInteger';
  }else if (currentInputType === 'Decimal'){return 'valueDecimal';
  }else if (currentInputType === 'Date'){return 'valueDate';
  }else if (currentInputType === 'Date Time'){return 'valueDateTime';
  }
}

export function isChart(it){
  return it === 'LINECHART' || it === 'BARCHART' || it === 'PIECHART'
}
export function gotStyleAndMargin(it){
  return isChart(it) || it === 'INPUT' || it === 'IMG' || it === 'VIDEO' || it === 'BUTTON' || it === 'ICON' || it === 'CARD' || it === 'CONTAINER' || it === 'HFLEX'  || it === 'DIV' || it === 'SPACE' || it === 'TIMER' || it === 'SUMMARY' || it === 'TABLE' || it === 'GALLERY' || it === 'TABS' || it === 'RADIO'
}


export function clean(x){
  return JSON.parse(JSON.stringify(x));
}

export const colors= [
      'rgb(97, 189, 109)',
      'rgb(26, 188, 156)',
      'rgb(84, 172, 210)',
      'rgb(44, 130, 201)',
      'rgb(147, 101, 184)',
      'rgb(71, 85, 119)',
      'rgb(204, 204, 204)',
      'rgb(65, 168, 95)',
      'rgb(0, 168, 133)',
      'rgb(61, 142, 185)',
      'rgb(41, 105, 176)',
      'rgb(85, 57, 130)',
      'rgb(40, 50, 78)',
      'rgb(0, 0, 0)',
      'rgb(247, 218, 100)',
      'rgb(251, 160, 38)',
      'rgb(235, 107, 86)',
      'rgb(226, 80, 65)',
      'rgb(163, 143, 132)',
      'rgb(239, 239, 239)',
      'rgb(255, 255, 255)',
      'rgb(250, 197, 28)',
      'rgb(243, 121, 52)',
      'rgb(209, 72, 65)',
      'rgb(184, 49, 47)',
      'rgb(124, 112, 107)',
      'rgb(209, 213, 216)'
    ];


export function sortOutBackgroundColor(newStyle, rawStyle, entityPath, currentList, internalVariables, width, height, upwardInfo, inputValues, ownVariables, urlParamsForExecution, urlHeader, chains, isPanel){

    var actVal = getStyleValueR('backgroundType', rawStyle, entityPath, currentList, internalVariables, width, height, upwardInfo, inputValues, ownVariables, urlParamsForExecution, urlHeader, chains);

    function getImage(newStyle){
      var actValSrc = getStyleValueR('src', rawStyle, entityPath, currentList, internalVariables, width, height, upwardInfo, inputValues, ownVariables, urlParamsForExecution, urlHeader, chains);
      if (actValSrc){
        newStyle.background = 'url('+actValSrc+')';
        if (rawStyle.stretchToFit){
          newStyle.backgroundSize = '100% 100%';
        }else{
          newStyle.backgroundSize = 'cover';
          if (isPanel){
            if (rawStyle.fixedBackground){
              newStyle.backgroundSize = (isPanel.relativeSize * 100) + '%';
              newStyle.backgroundAttachment = 'fixed';
              newStyle.backgroundPositionY = isPanel.panelOffsetT;
              newStyle.backgroundPositionX = isPanel.panelOffsetL;
            }
          }
        }
      }
    }

    function getBackground(newStyle){
      var actValBackground = getStyleValueR('backgroundColor', rawStyle, entityPath, currentList, internalVariables, width, height, upwardInfo, inputValues, ownVariables, urlParamsForExecution, urlHeader, chains);
      var gotGradient = getStyleValueR('gradient', rawStyle, entityPath, currentList, internalVariables, width, height, upwardInfo, inputValues, ownVariables, urlParamsForExecution, urlHeader, chains);
        if (gotGradient){
          var actValBackground2 = getStyleValueR('backgroundColor2', rawStyle, entityPath, currentList, internalVariables, width, height, upwardInfo, inputValues, ownVariables, urlParamsForExecution, urlHeader, chains);
          if (!actValBackground){
            actValBackground = 'black';
          }
          if (!actValBackground2){
            actValBackground2 = 'black';
          }
          var actDir = getStyleValueR('gradDir', rawStyle, entityPath, currentList, internalVariables, width, height, upwardInfo, inputValues, ownVariables, urlParamsForExecution, urlHeader, chains);
          if (!actDir){
            actDir = 0;
          }
          newStyle.background = 'linear-gradient('+actDir+'deg,' + actValBackground + ',' + actValBackground2 + ')'
      }else{
        if (actValBackground){
          newStyle.backgroundColor = actValBackground;
        }
      }
    }

    if (!actVal){
      getBackground(newStyle);
    }else if (actVal === 'image'){
      getImage(newStyle);
    }
}

function ColorToHex(color) {
  var hexadecimal = color.toString(16);
  return hexadecimal.length === 1 ? '0' + hexadecimal : hexadecimal;
}

function ConvertRGBtoHex(red, green, blue) {
  return '#' + ColorToHex(red) + ColorToHex(green) + ColorToHex(blue);
}

export function getHEXFromText(origColor){
  var red = 0;
  var green = 0;
  var blue = 0;
  if (origColor.indexOf('rgb') === 0){
    var rest = origColor.substr(4);
    var p = rest.indexOf(')');
    var inside = rest.substr(0, p);
    var xx = inside.split(',');
    red = +xx[0];
    green = +xx[1];
    blue = +xx[2];
    if (!red){
      red = 0;
    }
    if (!green){
      green = 0;
    }
    if (!blue){
      blue = 0;
    }
  }
  return ConvertRGBtoHex(red, green, blue);
}

export function getRGBFromText(origColor){
  var red = 0;
  var green = 0;
  var blue = 0;
  if (origColor){  
    if (origColor.indexOf('rgb') === 0){
      var rest = origColor.substr(4);
      var p = rest.indexOf(')');
      var inside = rest.substr(0, p);
      var xx = inside.split(',');
      red = +xx[0];
      green = +xx[1];
      blue = +xx[2];
    }
  }
  return {red, green, blue}

}


export function combineRGBAndOpacity(rgb, opacity){
  var pieces = getRGBFromText(rgb);
  return 'rgba(' + pieces.red + ', ' + pieces.green + ', ' + pieces.blue + ', ' + opacity + ')';
}

export function evaluateStyleR(itemT, rawStyle, entityPath, currentList, internalVariables, width, height, upwardInfo, inputValues, ownVariables, urlParamsForExecution, urlHeader, chains){

    var newStyle = {};

    if (rawStyle){
      var p1 = ResponsiveFns.stripOffLastItem(entityPath);
      var potentials = getPotentials(itemT, rawStyle, p1.priors, currentList);
      var executeRawStyle;
      var executeEntityPath;

      if (rawStyle.te){
        executeEntityPath = ['st', rawStyle.te.v, 's'];
        try{
          executeRawStyle = CoreFns.goDownPath(currentList, executeEntityPath);
        }catch(err){
          
        }
      }

      if (!executeRawStyle){
        executeRawStyle = rawStyle;
        executeEntityPath = entityPath;
      }
      potentials.forEach((tgt, index)=>{

        var usedRawStyle;
        var usedEntityPath;
        var pp = isToIgnore(tgt);
        if (pp){
          usedRawStyle = rawStyle;
          usedEntityPath = entityPath;
        }else{
          usedRawStyle = executeRawStyle;
          usedEntityPath = executeEntityPath;
        }

        var actVal = getStyleValueR(tgt, usedRawStyle, usedEntityPath, currentList, internalVariables, width, height, upwardInfo, inputValues, ownVariables, urlParamsForExecution, urlHeader, chains);
        if (actVal === false){
        }else{
          newStyle[tgt] = actVal;        
        }
      })

    }

    return newStyle;
  }

export function isToIgnore(p){
    var toIg = toIgnoreFromCommonSet();
    for (var i = 0; i < toIg.length; i++){
      if (p === toIg[i]){
        return true;
      }
    }
    return false;
  }
export function getStyleValueR(tgt, rawStyle, entityPath, currentList, internalVariables, width, height, upwardInfo, inputValues, ownVariables, urlParamsForExecution, urlHeader, chains){

    if (rawStyle){
      var val = rawStyle[tgt];
      if (val !== false && val !== null){
        try{
          return convertValToActVal(val, tgt, entityPath, currentList, internalVariables, width, height, upwardInfo, inputValues, ownVariables, urlParamsForExecution, urlHeader, chains);
        }catch(err){
          console.log(err);
          console.log(val);
          return {e:'error'}
        }
      }
    }
    return false
}

export function getValueAndUnitFromStyle(whichStyle, activeStylesList){
  for (var i = 0; i < activeStylesList.length; i++){
    var aStyle = activeStylesList[i];
    if (aStyle.t === whichStyle){
      var value = aStyle.v.v;
      var unit = aStyle.v.t;
      return {t:unit, v:value};
    }
  }
  return false;
}

export const cellStyle = {border:'1px solid #CCC', textAlign:'center', padding:'10px', whiteSpace: 'normal'};

export function toStopPropagation(e){
  e.stopPropagation();
}


function paddingSet(rawStylesObject){
  if (rawStylesObject.indvPadding && rawStylesObject.indvPadding.v){
    return ['paddingLeft', 'paddingRight', 'paddingTop', 'paddingBottom'];
  }else{
    return ['padding'];
  }
}

function modWithButtonColorSet(potentials, rawStylesObject, currentList){

  var toSee = rawStylesObject;
  if (rawStylesObject.te){
    var executeEntityPath = ['st', rawStylesObject.te.v, 's'];
    toSee = CoreFns.goDownPath(currentList, executeEntityPath);
  }

  if (toSee.buttonColorSet){
    potentials.push('backgroundColor');
    potentials.push('hoverColor');
  }else{
    potentials.push('buttonColor');
    potentials.push('buttonOutline');
  }  
}

function modWithToolTipSet(potentials, rawStylesObject, currentList){

  var toSee = rawStylesObject;
  if (rawStylesObject.te){
    var executeEntityPath = ['st', rawStylesObject.te.v, 's'];
    toSee = CoreFns.goDownPath(currentList, executeEntityPath);
  }

  if (toSee.tooltipSet){
    potentials.push('tooltipSet');
    potentials.push('tooltipLocation');
    potentials.push('toolText');
    potentials.push('tooltipShade');
  }
}

export function canScroll(it){
  return (it === 'IMG' || it === 'BUTTON' || it === 'VIDEO' || it === 'INPUT' || it === 'GALLERY' || it === 'TABLE' || it === 'HFLEX' || it === 'CONTAINER' || it === 'CARD');
}

//
export function getPotentials(itemI, rawStylesObject, path, currentList){
    var potentials = [];

    var iconSet = ['icon', 'iconColor', 'iconHeight', 'hW', 'iconWidth', 'iconRotation'];


    if (itemI === 'SPAN'){
      potentials = ['text', 'backgroundColor', 'color','B','I','U', 'fontSize', 'fontFamily'];
    }else if (itemI === 'DIV'){
      potentials = ['backgroundColor', 'textAlignment', 'lineHeight', 'overflowWrap'];
    }else if (itemI === 'IMGINFO'){
      potentials = ['sca', 'rot', 'cL', 'cT', 'cR', 'cB'];
    }else if (itemI === 'PANEL'){
      potentials = ['backgroundType'];
    }else if (itemI === 'PAGE'){
      potentials = ['w', 'backgroundColor', 'paddingOpacity', 'popUpPadding'];
    }else if (itemI === 'TABITEMCOVER'){
      potentials = ['text'];
    }else if (itemI === 'DAPP'){
      potentials = ['backgroundColor', 'color', 'fontFamily'];
    }else if (itemI === 'IMG'){ //IMAGE
      potentials = ['src', 'width', 'wh', 'height'];
    }else if (itemI === 'VIDEO'){ 
      potentials = ['videoId', 'width', 'height', 'loop', 'vDimensions'];
      // potentials = [{t:'width'}, {t:'height'},{t:'src'},{t:'padding'}, {t:'margin'},{t:'dispVis'},{t:'standAlone'}];
    }else if (itemI === 'INPUT'){ //inputbox
      potentials = ['inputType', 'inputSize', 'complexBackground', 'color', 'matchHeight', 'textAlignment', 'disabled', 'fontFamily', 'B','I','U', 'fontSize', ];
      // potentials = [{t:'width'}, {t:'height'},{t:'padding'}, {t:'margin'},{t:'dispVis'}];
      var inputType = rawStylesObject.inputType.v;
      potentials.push('placeholder');
      var allowMultiple = false;
      if (inputType === 'Radio'){
        allowMultiple = rawStylesObject.allowMultiple;
      }
      var valuePiece = getRelevantValueTgt(inputType, allowMultiple);
      potentials.push(valuePiece);
      if (inputType === 'Single Select'){ 
        potentials.push('options');
        potentials.push('selectStyle');
        potentials.push('shadeWhenHover')
        potentials.push('backgroundColor2');
      }else if (inputType === 'Radio'){
        potentials.push('options');
        potentials.push('radioTick');
        potentials.push('radioShape');
        potentials.push('outlineColor');
        potentials.push('tickColor');
        potentials.push('allowMultiple');
      }else if (inputType === 'Long Text'){
        potentials.push('numRows');
      }else if (inputType === 'UInteger' || inputType === 'Integer' || inputType === 'Decimal'){
        potentials.push('gotMinVal');
        potentials.push('gotMaxVal');
        var gotMinVal = rawStylesObject.gotMinVal;
        if (gotMinVal){
          potentials.push('minVal' + inputType);
          potentials.push('minValErrorText');
        }
        var gotMaxVal = rawStylesObject.gotMaxVal;
        if (gotMaxVal){
          potentials.push('maxVal' + inputType);
          potentials.push('maxValErrorText');
        }
      } 
      if (CoreFns.isInputTypeWithTooltip(inputType)){
        modWithToolTipSet(potentials, rawStylesObject, currentList);        
      }
    }else if (itemI === 'HR'){
      potentials = ['color'];
    }else if (itemI === 'alert'){
      potentials = ['buttonColor', 'buttonOutline', 'textAlignment'];
      modWithButtonColorSet(potentials, rawStylesObject, currentList);
    }else if (itemI === 'BUTTON' ){
      potentials = ['buttonSize', 'text', 'color', 'B','I','U', 'fontSize', 'fontFamily', 'disabled', 'buttonColorSet'].concat(iconSet);
      modWithButtonColorSet(potentials, rawStylesObject, currentList);
      modWithToolTipSet(potentials, rawStylesObject, currentList);
    }else if (itemI === 'ICON' ){
      potentials = iconSet.concat(['backgroundColor']);
    }else if (itemI === 'HFLEX'){
      potentials = ['complexBackground', 'noGutter', 'justifyContent', 'alignItems', 'rFormula', 'rowHeight'];
    }else if (itemI === 'CONTAINER' ){
      potentials = ['styled', 'complexBackground'];
    }else if (itemI === 'CARD'){
      potentials = ['backgroundColor'];
    }else if (itemI === 'NAV'){ 
      potentials = ['navbarCollapse', 'navbarTextShade', 'navbarCluster', 'backgroundColor', 'hoverEffect', 'menuIconColor'].concat(iconSet);
    }else if (itemI === 'navLink'){ 
      potentials = ['text', 'color','backgroundColor', 'B','I','U', 'fontSize', 'fontFamily'];
    }else if (itemI === 'navDropDown'){ 
      potentials = ['text', 'color','backgroundColor', 'B','I','U', 'fontSize', 'fontFamily'];
    }else if (itemI === 'navDropDownMenu'){ 
      potentials = ['menuBackgroundColor', 'width', 'specWidth'];
    }else if (itemI === 'TIMER'){ 
      potentials = ['time', 'reverse', 'stopAt0', 'hideSeconds', 'timerType', 'color', 'backgroundColor'];
      if (rawStylesObject && rawStylesObject.timerType && rawStylesObject.timerType.v === 'narrowTimer'){
      }else{
        potentials = potentials.concat(['legendColor', 'counterBackgroundColor', 'legendBackgroundColor', 'counterPadding', 'counterRadius']);
      }

    }else if (itemI === 'SUMMARY'){ 
      potentials = ['color', 'backgroundColor', 'detailsStyle'];
    }else if (itemI === 'SUMMARYDIV'){
      potentials = ['text', 'fontFamily', 'rFormula', 'textAlignment'];
    }else if (itemI === 'navBrand'){ 

      potentials = ['gotText', 'gotLogo', 'color','backgroundColor', 'B','I','U', 'fontSize', 'fontFamily', 'logoWidth'];
      if (rawStylesObject.gotText){
        potentials.push('text');
      }
      if (rawStylesObject.gotLogo){
        potentials.push('src');
        if (rawStylesObject.gotText){
          potentials.push('spacingGap');
        }
      }
    }else if (itemI === 'TABLE'){
      potentials = ['firstRowHeader', 'tableHover', 'tableStriped', 'tableBordered', 'tableDark'];
    }else if (itemI === 'TR'){
      potentials = ['backgroundColor'];
    }else if (itemI === 'TD'){
      potentials = ['backgroundColor'];
    }else if (isChart(itemI)){
      potentials = ['hideGrid', 'hideXAxis', 'hideYAxis', 'hideLegend', 'hideToolTip', 'yColor', 'xColor', 'fontSize'];
    }else if (itemI === 'LINEDATA'){
      potentials = ['dS', 'strokeColor', 'cap'];
    }else if (itemI === 'TABS'){
      potentials = ['backgroundColor'];
    }else if (itemI === 'TABITEMSGENERAL'){
      potentials = ['sBackgroundColor', 'uBackgroundColor', 'sColor', 'uColor', 'sBold', 'uBold', 'sUnderline', 'uUnderline'];
    }else if (itemI === 'TABITEM'){
      potentials = [];
    }else if (itemI === 'SPACE'){
      potentials = [];
    }else if (itemI === 'GALLERY'){
      potentials = ['backgroundColor', 'buttonsOutside', 'mvtIcon', 'srcList', 'hideCaption', 'capList', 'galleryHover', 'colWidthInternal'];
    }else if (itemI === 'GALLERYGENERAL'){
      potentials = [ 'textAlignment', 'B','I','U', 'fontSize', 'color','fontFamily'];
    }else if (itemI === 'GALLERYGENERALIMAGE'){
      potentials = ['width', 'minHeight', 'maxHeight'];
    }else if (itemI === 'GALLERYITEM'){
      potentials = [];
    }else if (!itemI){
    }else{
      console.warn(itemI);
    }

    if (itemI === 'DIV' || itemI === 'IMG' || itemI === 'INPUT' || itemI === 'alert' || itemI === 'GALLERYGENERALIMAGE' || itemI === 'navDropDownMenu' || itemI === 'CONTAINER' || itemI === 'HFLEX' || itemI === 'CARD' || itemI === 'TIMER' || itemI === 'BUTTON'){
      potentials.push('borderColor');
      potentials.push('borderWidth');
      potentials.push('borderStyle');

      if (rawStylesObject.indvRadius){
        potentials.push('borderTopLeftRadius');
        potentials.push('borderTopRightRadius');
        potentials.push('borderBottomLeftRadius');
        potentials.push('borderBottomRightRadius');

      }else{
        potentials.push('borderRadius');
      }
    }

    if (isFirstLevelAbsolute(path)){
      potentials.push('zIndex');
    }
    if (gotPaddingSet(itemI) || itemI === 'GALLERYGENERAL' || itemI === 'TABITEMSGENERAL'){
      potentials = potentials.concat(paddingSet(rawStylesObject));
    }
    if (gotStyleAndMargin(itemI)){
      if (path.length > 6){
        var parentalPiece = CoreFns.goDownPath(currentList, path, 2);

        if (!parentalPiece.t){
          var pMinus3 = path[path.length - 4];
          if (pMinus3 === 'al'){
          }else{
            console.log(pMinus3);
            console.log(currentList);
            console.log(path);
            console.log(parentalPiece);            
          }
          // throw new Error('x');
        }
        if (parentalPiece.t === 'HFLEX'){
          potentials.push('colWidth');
          potentials.push('mt');
          potentials.push('mb');
          potentials.push('ml');
          potentials.push('mr');
        }
      }else{
          potentials.push('mt');
          potentials.push('mb');
          potentials.push('ml');
          potentials.push('mr');
      }
    }
    if (path.length > 6){
      var parentalPiece1 = CoreFns.goDownPath(currentList, path, 2);
      if (parentalPiece1.t === 'HFLEX'){
        if (itemI === 'IMG' || itemI === 'INPUT'){
          potentials.push('vTop');
        }

      }
    }
    potentials.push('gHideWhen');

    if (canScroll(itemI)){
      potentials.push('scrollIn');
    }


    return potentials;    
}

export function gotPaddingSet(it){
  return it === 'DIV' || it === 'BUTTON' || it === 'INPUT' || it === 'ICON'  || it === 'IMG'  
}
export function convertToDivs(text, width){
  return text.split('\n').map((aLine, index)=>{
    if (aLine.length === 0){
      return <div key={index}>&nbsp;</div>
    }

    if (aLine.indexOf('Img:') === 0){
      return <center><img alt='' style={{width:width * 0.8, padding:'20px'}} src={aLine.substr(4)} /></center>
    }
//
    var countNosTabs =  aLine.split('\t').length - 1;
    return <div style={{paddingLeft:countNosTabs*10}} key={index}>{aLine}</div>
  });
      //
}        

export function minScreenSize(screenSize){
  var amt = 576;
  if (screenSize === 2){
    amt = 768
  }else if (screenSize === 3){
    amt = 992
  }else if (screenSize === 4){
    amt = 1200;
  }
  return amt;  
}

export function toIgnoreFromCommonSet(){
  return ['text', 'ord', 'src', 'icon', 'iconColor', 'iconHeight', 'te'];
}

export function whichSize(width){
  if (width >= 1200){
    return 'xl';
  }else if (width >= 992){
    return 'lg';
  }else if (width >= 768){
    return 'md';
  }else if (width >= 576){
    return 'sm';
  }else{
    return 'norm';
  }
}

export function isRawTextStyle(tgt){
  return tgt === 'placeholder' || tgt === 'valueString' || tgt === 'text' || tgt === 'videoId' || tgt === 'src' || tgt === 'toolText' || tgt === 'minValErrorText' || tgt === 'maxValErrorText' || tgt === 'cap'
}

export function isRawBooleanStyle(tgt){
  return tgt === 'navbarCollapse' || tgt === 'navbarSticky' || tgt === 'footerSticky' || tgt === 'navbarCluster' || tgt === 'styled' || tgt === 'reverse' || tgt === 'gotText' || tgt === 'gotLogo' || tgt === 'hideLegend' || tgt === 'matchHeight' || tgt === 'sBold' || tgt === 'uBold' || tgt === 'sUnderline' || tgt === 'uUnderline' || tgt === 'B' || tgt === 'I' || tgt === 'U' || tgt === 'hideGrid' || tgt === 'hideYAxis' || tgt === 'hideXAxis' || tgt === 'hideToolTip' || tgt === 'firstRowHeader' || tgt === 'hideCaption' || tgt === 'buttonsOutside' || tgt === 'disabled' || tgt === 'specWidth' || tgt === 'gHideWhen' || tgt === 'tooltipSet' || tgt === 'stopAt0'|| tgt === 'hideSeconds' || tgt === 'gotMinVal' || tgt === 'gotMaxVal' || tgt === 'allowMultiple'
}

export function modStyleWithFlashHighlight(style, flashHighlight, itemInfoPathString){
  if (flashHighlight){
    if (flashHighlight.screenPathString === itemInfoPathString){
      if (flashHighlight.i){
        style.backgroundColor = flashHighlight.color;
        style.border = '2px solid white';
      }else{
        style.backgroundColor = 'white';
        style.border = '2px solid ' + flashHighlight.color;
      }
    }
  }

}
export function dispDateOrDateTime(valIn, columnType){
  var val = new Date(valIn * 1000);
  if (columnType === 'Date'){
    return pad(val.getDate()) + '/' + pad(val.getMonth() + 1) + '/' + val.getFullYear();
  }else if (columnType === 'Date Time'){
    return pad(val.getDate()) + '/' + pad(val.getMonth() + 1) + '/' + val.getFullYear() + ' ' + pad(val.getHours()) + ':' + pad(val.getMinutes()) + ':' + pad(val.getSeconds());
  }
}

function pad(nos){
  if (nos < 10){
    return '0' + nos;
  }else{
    return nos;
  }
}

export function isRawIntegerStyle(tgt){
  return tgt === 'valueInteger' || tgt === 'minValInteger' || tgt === 'maxValInteger'
}

export function isRawUIntegerStyle(tgt){
  return tgt === 'valueUInteger' || tgt === 'minValUInteger' || tgt === 'maxValUInteger' 
}

export function isRawDecimalStyle(tgt){
  return tgt === 'valueDecimal' || tgt === 'minValDecimal' || tgt === 'maxValDecimal' 
}


export function convertValToActVal(val, tgt, entityPath, currentList, internalVariables, width, height, upwardInfo, inputValues, ownVariables, urlParamsForExecution, urlHeader, chains){
  if (val === undefined){
    return false;
  }
  var type = val.t;
  if (val.t === undefined){
    if (isRawTextStyle(tgt)){
      return val;
    }else if (tgt === 'time' || isRawIntegerStyle(tgt) || isRawUIntegerStyle(tgt)){
      return BigInt(val);
    }else if (isRawDecimalStyle(tgt) || tgt === 'zIndex' ){
      return +val;
    }else if (isRawBooleanStyle(tgt)){
      if (val){return true}else{return false};
    }else if (tgt === 'overflowWrap'){
      if (val){
        return 'break-word';
      }else{
        return '';
      }
    }else if (tgt === 'srcList'){
      var dataKeys = CoreFns.sortedKeyList(val.s);
      return dataKeys.map((aDataKey, index)=>{
        return convertValToActVal(val.s[aDataKey].v, 'src', entityPath.concat(['s', aDataKey, 'v']), currentList, internalVariables, width, height, upwardInfo, inputValues, ownVariables, urlParamsForExecution, urlHeader, chains);
      })
    }else if (tgt === 'capList' || tgt === 'options' || tgt === 'valueListString'){
      if (!val.s){
        val = {s:{}};
      }
      var dataKeys1 = CoreFns.sortedKeyList(val.s);
      return dataKeys1.map((aDataKey, index)=>{
        return convertValToActVal(val.s[aDataKey].v, 'text', entityPath.concat(['s', aDataKey, 'v']), currentList, internalVariables, width, height, upwardInfo, inputValues, ownVariables, urlParamsForExecution, urlHeader, chains);
      })
    }else if (tgt === 'dS'){
      var dataKeys2 = CoreFns.sortedKeyList(val.s);
      return dataKeys2.map((aDataKey, index)=>{
        var aVal = convertValToActVal(val.s[aDataKey].v.a, 'time', entityPath.concat(['s', aDataKey, 'v', 'a']), currentList, internalVariables, width, height, upwardInfo, inputValues, ownVariables, urlParamsForExecution, urlHeader, chains);
        var bVal = convertValToActVal(val.s[aDataKey].v.b, 'valueDecimal', entityPath.concat(['s', aDataKey, 'v', 'b']), currentList, internalVariables, width, height, upwardInfo, inputValues, ownVariables, urlParamsForExecution, urlHeader, chains);
        return {date:aVal, value:bVal};
      })
    }else if (tgt === 'hW'){
      return false;
    }else{
      console.warn(tgt);
      console.warn(val);
    }
  }
  var value = val.v;
  if (type === 'px'){
    return value + type;
  }else if (type === 'vw' || type === 'vh'  || type === 'em'){
    var oD1 = EditorHelpers.reverseScale(value, type, 'w', width, height);
    return oD1 + 'px';
  }else if (type === 'perc'){
    return value + '%';
  }else if (type === 'int' || type === 'dc'){
    return +value;
  }else if (type === 'bsu'){
    if (width >= 1200 && val.xl !== undefined){
      return +val.xl
    }else if (width >= 992 && val.lg !== undefined){
      return +val.lg
    }else if (width >= 768 && val.md !== undefined){
      return +val.md
    }else if (width >= 576 && val.sm !== undefined){
      return +val.sm
    }else{
      return +val.v;
    }
  }else if (type === 'comb'){

    var oD = EditorHelpers.reverseScale(value.var.v, value.var.t, 'w', width, height);
    return (oD + value.fixed) + 'px';

    // return 'calc(' + value.fixed + 'px + ' + value.var.v + value.var.t + ')';
  }else if (type === 'formula'){
    return FormulaFunctions.evaluateCondition(val, {t:'noNeedToSpecifyCosConfirmFormula'}, entityPath, currentList, internalVariables, width, height, upwardInfo, inputValues, ownVariables, urlParamsForExecution, urlHeader, chains);
  }else if (type === 'raw'){
    if (width >= 1200 && val.xl !== undefined){
      return val.xl
    }else if (width >= 992 && val.lg !== undefined){
      return val.lg
    }else if (width >= 768 && val.md !== undefined){
      return val.md
    }else if (width >= 576 && val.sm !== undefined){
      return val.sm
    }else{
      return val.v;
    }
  }else if (type === 'align' || type === 'vAlign' || type === 'style' || type === 'font' || type === 'subtitleList' || type === 'columnList' || type === 'bool' || type === 'inputType' || type === 'dispVis' || type === 'treePresMode'){
    return value
  }else if (type === 'null'){
    return 'null';
  }else if (!type || !value){
    return false;
  }else{
    console.warn(val);
  }
}

